interface LinkedThread {
	origin: string | null
}

interface LegacyVoter {
	contact?: unknown
}

// Portal upvotes arrive as threads with the UPVOTE origin; the deprecated v1 API
// still writes voter rows, so the tab shows and counts both.
export function countUpvotes(
	threads: readonly LinkedThread[],
	legacyVoters: readonly LegacyVoter[],
): number {
	const upvoteThreads = threads.filter((t) => t.origin === "UPVOTE").length
	const voters = legacyVoters.filter((v) => v.contact).length
	return upvoteThreads + voters
}
